import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lnhCompartName'
})
export class LnhCompartNamePipe implements PipeTransform {

  transform(compartName: string): any {
    switch (compartName) {
      case "Link":
        return "Shoe";
      case "Sprocket":
        return "Tumbler";
      default:
        return compartName;
    }
  }

}
